/*
<summary>
   This enum defines the tool_master.inspection_cycle values — rendered as radio buttons on
   the Add/Edit Tool form; selecting "Periodic" reveals the InspectionInterval days input.
   Developer: Aashish Singh, Created Date: 25-Aug-2026
</summary>
*/
enum InspectionCycleEnum {
  PreWork = 0,
  OnApplicatorSwap = 1,
  Periodic = 2,
  None = 3,
}

export default InspectionCycleEnum;
